import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from "vue";
import { usePresenter } from "./presenter";
interface IProps {
  name: string;
}
interface IEmit {
  (event: "update", name: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    name: { default: "hello" }
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
  (event: "update", name: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { name: string };





const presenter = usePresenter(props, emit);
const { model } = presenter;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(presenter).handleClick && _unref(presenter).handleClick(...args)))
  }, _toDisplayString(props.name), 1))
}
}

})